module.exports = __webpack_public_path__ + "src/app/_content/imgs/discover/mot/All_models.png?3aed6b0cc5abde36e7e903803c3d0a7d";